import { LogOut } from 'lucide-react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { RoleBadge } from '@/auth/RoleBadge';
import { useSession, useLogout } from '@/auth/hooks';

// Port of DrawerProfile (DrawerPane.kt:180-300): avatar initial, name, up to 2 role badges + overflow, logout.
export function DrawerProfile() {
  const { email, name, roles } = useSession();
  const logout = useLogout();
  const display = name || email || 'User';

  return (
    <div className="mt-2 border-t border-sidebar-border/30 px-4 pt-3">
      <div className="flex items-center gap-2.5">
        <Avatar>
          <AvatarFallback>{display[0]?.toUpperCase() ?? 'U'}</AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-1.5">
            <span className="truncate text-sm font-medium">{display}</span>
            {roles.slice(0, 2).map((r) => (
              <RoleBadge key={r} role={r} />
            ))}
            {roles.length > 2 && (
              <span className="text-xs text-muted-foreground">+{roles.length - 2}</span>
            )}
          </div>
          {name && email && <p className="truncate text-xs text-muted-foreground">{email}</p>}
        </div>
      </div>
      <Button variant="secondary" size="sm" className="mt-2.5 w-full" onClick={logout}>
        <LogOut /> Log out
      </Button>
    </div>
  );
}
